import React from "react";
import {
  Text,
  Panel,
  Stack,
  FontIcon,
  PanelType,
} from "office-ui-fabric-react/lib";

export interface CustomDrawerProps {
  title?: string;
  handelOpen?: boolean;
  class?: string;
  onClose: Function;
  drawerType?: PanelType;
  customWidth?: string;
}

export interface CustomDrawerState { }

class CustomDrawer extends React.Component<
  CustomDrawerProps,
  CustomDrawerState
> {
  constructor(props: CustomDrawerProps) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <Panel
        isBlocking={true}
        type={this.props.drawerType || PanelType.medium}
        hasCloseButton={false}
        className={`drawer ${this.props.class}`}
        isOpen={this.props.handelOpen === false ? false : true}
        onDismiss={() => this.props.onClose()}
        onOuterClick={() => undefined}
        customWidth={this.props.customWidth || "600px"}
        focusTrapZoneProps={{ disabled: true }}
      >
        <section>
          {this.props.title && (
            <div className="custom-drawer-header">
              <Stack horizontal horizontalAlign="space-between">
                <Text>{this.props.title}</Text>
                <FontIcon
                  onClick={() => this.props.onClose()}
                  className="pointer"
                  iconName="ChromeClose"
                />
              </Stack>
            </div>
          )}
          <div>{this.props.children}</div>
        </section>
      </Panel>
    );
  }
}

export default CustomDrawer;
